import { Popover } from '@mui/material';
import { isEqual, sortBy } from 'lodash';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import CrossIcon from '../../../assets/svg/CrossIcon';
import { STATUSES } from '../../../constants';
import { Button, Checkbox } from '../../Shared';

export const StatusFilter = ({ statuses, onChangeStatuses }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currStatuses, setCurrStatuses] = useState(statuses);

  const onChangeCurrStatuses = status => {
    setCurrStatuses(prev => {
      const isSelected = prev.includes(status);

      if (isSelected) return prev.filter(v => v !== status);

      return [...prev, status];
    });
  };

  const onChange = () => {
    onChangeStatuses(prev => {
      return {
        ...prev,
        statuses: currStatuses,
      };
    });
    onClosePopover();
  };

  const reset = () => {
    onChangeStatuses(prev => {
      return {
        ...prev,
        statuses: [],
      };
    });
  };

  const onOpenPopover = e => {
    if (e.target.localName !== 'button') return;
    setCurrStatuses(statuses);
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const hasStatuses = statuses.length > 0;
  const isButtonApplyDisabled = isEqual(sortBy(statuses), sortBy(currStatuses));
  const isFilteredByAllStatuses =
    statuses.length === 0 || statuses.length === STATUSES.length;

  return (
    <>
      <button
        className={twMerge(
          'flex items-center gap-2 rounded-full py-[11px] px-6 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] focus-visible:outline-none',
          hasStatuses && 'bg-brand-900 text-white !pl-6 !pr-5',
        )}
        onClick={onOpenPopover}
      >
        {isFilteredByAllStatuses
          ? 'Status - All'
          : `Status +${statuses.length}`}
        {hasStatuses && (
          <div onClick={reset}>
            <CrossIcon className="w-4 h-4 text-white" />
          </div>
        )}
      </button>
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-xl mt-2 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-60',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="overflow-hidden">
          <div className="p-1 flex flex-col gap-1 max-h-[268px] overflow-auto">
            {STATUSES.map(({ value, label, color }) => {
              const checked = currStatuses.includes(value);

              return (
                <label
                  key={value}
                  className="flex items-center justify-between py-1 pl-1 pr-3 cursor-pointer rounded-lg hover:bg-brand-300/[0.08]"
                >
                  <div className="flex items-center gap-2 truncate">
                    <Checkbox
                      checked={checked}
                      onChange={() => {
                        onChangeCurrStatuses(value);
                      }}
                    />
                    <span className="text-[16px]/[24px] text-base-1000 truncate">
                      {label}
                    </span>
                  </div>
                  <div className={`w-3 h-3 rounded-[2px] ${color} shrink-0`} />
                </label>
              );
            })}
          </div>
          <div className="px-4 py-3 border-t border-t-base-200">
            <Button
              title="Apply"
              onClick={onChange}
              disabled={isButtonApplyDisabled}
              className="ml-auto"
            />
          </div>
        </div>
      </Popover>
    </>
  );
};
